import { BulkSignOrchestratorApiTypes } from "@rshbintech.dboul/http";
import { BatchedDocumentsItemMap, Document } from "../types";
import { matchCcb } from "./match-ccb";

export const updateDocumentsWithCcb = (
  unsignedDocuments: Document[],
  ccb: BulkSignOrchestratorApiTypes.CcbData[]
): BatchedDocumentsItemMap => {
  const documents = matchCcb(unsignedDocuments, ccb);

  const idsWithCcb: BatchedDocumentsItemMap = {};

  documents.forEach((document) => {
    if (!idsWithCcb[document.id]) {
      idsWithCcb[document.id] = document;
    }
  });

  return idsWithCcb;
};
